import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import c from 'classnames';
import { showMobileMenu, hideMobileMenu } from '../../../actions/UI';

import { Container, StickyCTA, NavToggle, Logo } from '../../../components';
import NavigationMainMenu from '../../Menu/NavigationMainMenu';

import AnimationWrapper from '../AnimationWrapper';

import './style.scss';

class NavigationFull extends Component {
  constructor() {
    super();

    this.state = {
      visible: false,
      reachedTop: true,
      scrolledPastNavHeight: true,
    };
  }

  onUpdateAnimationWrapper = (isVisible, hasReachedTop, scrolledPastNavHeight) => {
    const shouldUpdate = (
      this.state.visible !== isVisible
      || this.state.reachedTop !== hasReachedTop
      || this.state.scrolledPastNavHeight !== scrolledPastNavHeight
    );

    if (shouldUpdate) {
      this.setState({
        scrolledPastNavHeight,
        visible: isVisible,
        reachedTop: hasReachedTop,
      });
    }
  };

  onHamburgerClick = () => {
    if (this.props.mobileMenuVisible) {
      this.props.dispatch(hideMobileMenu());
    } else {
      this.props.dispatch(showMobileMenu());
    }
  };

  render() {
    const { reachedTop, visible, scrolledPastNavHeight } = this.state;
    const { path, mobileMenuVisible, withStickyCTA, childEntity, onVacancyApply, whatsappLink, entityBundle } = this.props;
    const type = childEntity.getIn(['type', 0, 'target_id']);
    const classes = c('Navigation', {
      's-reached-top': reachedTop,
      's-visible': visible,
      's-scrolled-past-nav-height': scrolledPastNavHeight,
    });

    return (
      <AnimationWrapper onUpdate={this.onUpdateAnimationWrapper} scrollOffset={200} hasBackground={type !== 'campaign_page'}>
        <React.Fragment>
          <div className="Navigation-wrapper" data-has-background={type === 'campaign_page'}>
            <Container className="Navigation-container">
              <div className={classes}>
                <div className="Navigation__top">
                  <Logo />
                  <NavToggle onHamburgerClick={this.onHamburgerClick} menuIsOpen={mobileMenuVisible} />
                </div>
                <NavigationMainMenu path={path} />
              </div>
            </Container>
          </div>
          {withStickyCTA && (
            <StickyCTA
              childEntity={childEntity}
              onVacancyApply={onVacancyApply}
              whatsappLink={whatsappLink}
              type={entityBundle}
            />
          )}
        </React.Fragment>
      </AnimationWrapper>
    );
  }
}

function mapStateToProps(state) {

  return {
    path: state.getIn(['router', 'location', 'pathname']),
    mobileMenuVisible: state.getIn(['uiInternal', 'showMobileMenu']),
  };
}

export default withRouter(connect(mapStateToProps)(NavigationFull));
